import React from 'react'
import { motion } from 'framer-motion'
import Container from './Container'
import SimaLeadForm from './SimaLeadForm'

const ContactClosingSima: React.FC = () => {
  return (
    <section className="bg-primary py-24 md:py-32 relative overflow-hidden text-white" id="contacto">
      {/* Abstract Background Design */}
      <div className="absolute inset-0 z-0 opacity-20 bg-[url('https://images.unsplash.com/photo-1542744173-8e7e53415bb0?q=80&w=2070&auto=format&fit=crop')] bg-cover bg-center mix-blend-overlay"></div>
      <div className="absolute inset-0 bg-gradient-to-b from-primary via-primary/95 to-primary"></div>
      
      <Container size="lg" className="relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-100px' }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="font-display text-4xl font-bold md:text-5xl lg:text-6xl mb-6 text-balance">
              Agenda tu cita en SIMA (IFEMA Madrid)
            </h2>
            <p className="text-xl text-secondary-light/90 mb-10 max-w-lg">
              Completa el formulario y te confirmamos disponibilidad. Cupos limitados por agenda para las reuniones presenciales.
            </p>

            <div className="space-y-6">
              <div className="flex items-center gap-4">
                <div className="flex h-12 w-12 items-center justify-center rounded-full bg-accent/20 text-accent-light">
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                </div>
                <div>
                  <h4 className="font-bold text-lg">Cupos Limitados</h4>
                  <p className="text-secondary-light/70 text-sm">Reserva con anticipación para asegurar tu espacio 1:1.</p>
                </div>
              </div>
              
              <div className="flex items-center gap-4">
                <div className="flex h-12 w-12 items-center justify-center rounded-full bg-accent/20 text-accent-light">
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path></svg>
                </div>
                <div>
                  <h4 className="font-bold text-lg">Asesoría Gratuita</h4>
                  <p className="text-secondary-light/70 text-sm">Sin compromiso de compra inicial.</p>
                </div>
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: '-100px' }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="text-text-primary"
          >
            <SimaLeadForm id="footer" />
          </motion.div>

        </div>
      </Container>
    </section>
  )
}

export default ContactClosingSima
